import { render, staticRenderFns } from "./ContMyReportsComponent.vue?vue&type=template&id=f8352408&scoped=true&lang=pug"
import script from "./ContMyReportsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyReportsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8352408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8352408')) {
      api.createRecord('f8352408', component.options)
    } else {
      api.reload('f8352408', component.options)
    }
    module.hot.accept("./ContMyReportsComponent.vue?vue&type=template&id=f8352408&scoped=true&lang=pug", function () {
      api.rerender('f8352408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyReportsComponent.vue"
export default component.exports